import { render, staticRenderFns } from "./ProcessoRevisao.vue?vue&type=template&id=0060d916&scoped=true"
import script from "./ProcessoRevisao.vue?vue&type=script&lang=js"
export * from "./ProcessoRevisao.vue?vue&type=script&lang=js"
import style0 from "./ProcessoRevisao.vue?vue&type=style&index=0&id=0060d916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0060d916",
  null
  
)

export default component.exports